import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { LEGAL_TEXTOS } from "@/constants/legal";

export default function Legal() {
  const { pathname } = useLocation();
  const contenido = LEGAL_TEXTOS[pathname];

  if (!contenido) return null;

  return (
    <main className="pt-[72px]">
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-8 lg:py-28">
        <Reveal>
          <h1 className="font-serif text-4xl text-tinta sm:text-5xl">{contenido.titulo}</h1>
          {contenido.parrafos.map((p) => (
            <div key={p.titulo} className="mt-10">
              <h2 className="font-serif text-xl text-tinta sm:text-2xl">{p.titulo}</h2>
              <p className="mt-3 leading-relaxed text-tinta/70">{p.texto}</p>
              {p.lista && (
                <ul className="mt-3 list-disc space-y-1.5 pl-5 leading-relaxed text-tinta/70">
                  {p.lista.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <Link
            to="/"
            data-testid="legal-back-link"
            className="mt-14 inline-flex items-center gap-2 rounded-full border border-arena px-6 py-3 text-sm font-semibold text-chocolate transition-colors hover:bg-arena/40"
          >
            <ArrowLeft className="h-4 w-4" /> Volver al inicio
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
